<template>
    <div class="cart-dropdown dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
        <form>
            <!-- begin:: Mycart -->
                <div class="d-flex align-items-center py-5 px-8 bgi-size-cover bgi-no-repeat rounded-top ">
                    <div class="col-md-6 p-0">
                        <h4 class="font-weight-bolder">{{$t('order')}} {{$t('summary')}}</h4> 
                         <span style="color:#1bac94">{{$t('total_products')}} : {{count}} </span> 
                    </div>
                    <div class="col-md-6" v-if="products.length > 0">
                       <button type="button" class="btn= btn-link btn-sm float-right" style="color:#e76450" @click="ClearCartProducts">{{$t('clear_all')}}</button>
                    </div>
                </div>
                <div v-if="products.length" class="scroll scroll-push cart-scrollable" data-scroll="true" data-height="250" data-mobile-height="200">
                     <div  class="separator separator-solid"></div>
                    <!--begin::Item-->
                    <div v-for="(product, index) in products" :key="index" class="d-flex align-items-center justify-content-between px-8 py-5 border-bottom">
                        <div class="d-flex flex-column mr-2" >
                            <span class="font-weight-bolder text-dark-75 font-size-lg w-200px">{{ product.show_name }}</span>
                            <span class="text-muted" v-if="!($store.getters.role == 'customer-contact' && $store.getters.brand.hide_sku_on_shop == '1')">{{ product.sku }}</span>
                            <div class="d-flex align-items-center mt-2">
                                <!-- Implement the STore setting hide price in shop view  -->
                                <span class="font-weight-bold mr-1 text-dark-75 font-size-lg" v-if="$store.getters.brand.hide_price_shop_view=='0'">{{product.currency_symbol}}{{commaSeprator(product.dp * parseFloat(product.quantity))}}</span>
                                <span class="text-muted mr-1" v-if="$store.getters.brand.hide_price_shop_view=='0'">{{$t('for')}}</span>
                                <span class="text-muted mr-1" v-if="$store.getters.brand.hide_price_shop_view=='1'">{{$t('qty')}}</span>
                                <span class="font-weight-bold mr-2 text-dark-75 font-size-lg">{{commaSeprator(parseFloat(product.quantity))}}</span>
                                <a href="#" class="btn btn-xs btn-light-primary btn-circle btn-icon mr-2" @click.prevent="decrementCartProductUI(product,index)">
                                    <i class="fa fa-minus icon-xs"></i>
                                </a>
                                <a href="#" class="btn btn-xs btn-light-primary btn-circle btn-icon" @click.prevent="incrementCartProductUI(product,index)">
                                    <i class="fa fa-plus icon-xs"></i>
                                </a>
                            </div>

                        </div>
                        <div class="d-flex flex-column mr-2">
                           <a>
                             <!--    <div class="align-right btn btn-label-danger" @click.prevent="">x</div> -->
                                <span class="float-right">
                                   <a href="#"> <i class="far  fa-times-circle fa-lg text-danger mb-2" @click.prevent="removeCartProduct(product)"></i></a>
                                </span>
                            </a>
                            <a href="#" v-if="product.image" class=" form-text symbol symbol-70 symbol-circle flex-shrink-0">
                               <img :src="getBrandImageUrl(product.image)" title="" alt="">
                            </a>
                            <a href="#" v-else class="form-text symbol symbol-70 symbol-circle flex-shrink-0">
                                <img  src="/images/no-image-500x500.jpg" title="" alt="" />
                            </a>
                        </div>


                    </div>
                    <!--end::Item-->
                    <!-- <div  class="separator separator-solid"></div> -->
                 </div>
                 <!-- Implement the STore setting hide price in shop view  -->
                 <div class="p-8" v-if="products.length > 0">
                    <div class="d-flex align-items-center justify-content-between mb-4" v-if="$store.getters.brand.hide_price_shop_view=='0'">
                        <span class="font-weight-bolder font-size-h6 mr-2" style="color:#e76450">{{$t('total')}}</span>
                        <span class="font-weight-bolder font-size-h6 text-right" style="color:#e76450">{{currency}}{{commaSeprator(subtotal)}}</span>
                    </div>

                    <div class="text-right">
                       <button class="btn btn-primary btn-sm form-control" @click.prevent="updateCartProductQuantity" :disabled="quantityBtnDisable">{{$t('update')}}</button>
                       <router-link class="btn btn-success btn-sm form-control mt-2 p-3" to="/shop/orders/create" role="button" v-if="['customer'].includes(store.getters.role) ||  store.getters.permissions.includes('create_order')">{{$t(store.state.brand.subdomain === 'cosmossuperiorfoods' ? 'review' : 'place')}} {{$t('order')}}</router-link>
                   </div>
                </div>
            <!-- end:: Mycart -->
        </form>
    </div>
</template>
<script setup>
import CustomerAPIService from '@/js/api/customers/customers';
import ShopAPIService from '@/js/api/store/shop';
import eventBus from '@/js/utils/eventBus';
// import Notifications from 'vue-notification';
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import {toast} from "vue3-toastify";
import 'vue3-toastify/dist/index.css';
import { getBrandImageUrl } from '@/js/utils/common.js';

const products = ref([]);
const count = ref(0);
const subtotal = ref(0);
const currency = ref('');
const store_credit = ref(0);
const discount = ref(0);
const quantityBtnDisable = ref(false);
const route = useRoute();
const store = useStore();
const emit = defineEmits(['productCount']);
const APIURL = import.meta.env.VITE_API_URL;

onMounted(async() => {

const restrictSingleCategoryOrder = store.state.brand.restrict_single_category_order;
  // Add flag check
  const clearedOnce = localStorage.getItem('cartCleared');

  if ((restrictSingleCategoryOrder == "1" || restrictSingleCategoryOrder == 1) && !clearedOnce) {
    try {
      const response = await ShopAPIService.clearShopCart({});
      if (response.data.hasOwnProperty("success")) {
        localStorage.setItem('cartCleared', 'true'); 
        await getCartProducts(); 
      } else if (response.data.hasOwnProperty("error")) {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Error Exception!");
    }
  } else if (restrictSingleCategoryOrder == "0" || restrictSingleCategoryOrder == 0)  {
    localStorage.removeItem('cartCleared'); 
  }

    await getCartProducts();
  eventBus.on('refreshCart', () => {
    getCartProducts();
  })
});

// onBeforeUnmount(() => {
//   eventBus.off('refreshCart');
// });

const removeCartProduct = async (product) => {
  try {
    const response = await CustomerAPIService.deleteCartProducts(product.cartProduct_id);
    if (response.data.hasOwnProperty("success")) {
      toast.success(response.data.success);
      getCartProducts();
    } else if (response.data.hasOwnProperty("error")) {
      toast.error(response.data.error);
    }
  } catch (error) {
    toast.error('Something went wrong while removing the product.');
  }
};

const removeProductFromCart = async (productId) => {
    const response = await CustomerAPIService.deleteCartProducts(productId);
    // May used in future
    // if (response.data.success) {
    //   toast.success(response.data.success);
    // } else if (response.data.error) {
    //   toast.error(response.data.error);
    // }
};

const ClearCartProducts = async () => {
  let data = {};
  let result = await swal.fire({
    title: "Are you sure you want to clear cart?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, Clear it!",
  })
  if (result.isConfirmed) {
    try {
      const response = await ShopAPIService.clearShopCart(data);
      if (response.data.hasOwnProperty("success")) {
        getCartProducts();
        toast.success(response.data.success);
      } else if (response.data.hasOwnProperty("error")) {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Error Exception!");
    }
  }
};

// Function to handle removal of sold-out products from the cart
const removeSoldOutProducts = async (cartProducts) => {
  const soldOutProducts = cartProducts.filter(product => product.so === true);
  if (soldOutProducts.length > 0) {
    await Promise.all(
      soldOutProducts.map(item => removeProductFromCart(item.cartProduct_id))
    );
  }
};
const getCartProducts = async () => {
  try {
    const response = await CustomerAPIService.getAllCartProducts();
   if (response.data.hasOwnProperty("cartProducts")) {
    const data = response.data;
    // getting all roles from store settings
    const allCartProducts = data.cartProducts || [];
    const rolesString = store.state.brand_settings.sell_soldout_products_roles || '';
    const allowedRoles = rolesString
      .split(',')
      .map(role => role.trim().toLowerCase())
      .filter(role => role.length > 0);

    let finalCart = [...allCartProducts];

        // If the user is not allowed to see sold-out products, remove them
    if (!allowedRoles.includes("customer" || "staff" || "admin")) {
      await removeSoldOutProducts(finalCart);
      finalCart = finalCart.filter(item => item.so === false);
    }


    count.value = finalCart.length;
    let totalQuantity = 0;
    finalCart.forEach(item => {
      totalQuantity += parseFloat(item.quantity);
    });
    emit('productCount', totalQuantity);
    store.commit('SET_CART_PRODUCTS', finalCart);
    products.value = finalCart;
    currency.value = data.currency_symbol;
    recalculateTotal();
   }
  }
  catch (err) {
    toast.error("Error Exception!");
  }
};

const incrementCartProductUI = (product, index) => {
  const {
    cartProduct_id,
    max_purchase_quantity: maxQtyRaw,
    min_purchase_quantity: minQtyRaw
  } = product;
  // Parse numbers once
  const minQty = parseFloat(minQtyRaw) || 0;
  const maxQty = maxQtyRaw ? parseFloat(maxQtyRaw) : null;
  // Cache the “allow multiple” flag
  const allowMultiple = store.getters['brand']
    .allow_multiple_of_minimum_purchase_quantity === "1";
  // Find the matching row just once
  const row = products.value.find(r => r.cartProduct_id === cartProduct_id);
  if (!row) return;
  // Calculate the new quantity
  const currentQty = parseFloat(row.quantity) || 0;
  const incrementBy = allowMultiple ? minQty : 1;
  let newQty = currentQty + incrementBy;

  // If there’s a max and we exceed it, warn and revert
  if (maxQty !== null && newQty > maxQty) {
    toast.warning(`Maximum purchase quantity is ${maxQty}.`);
    newQty = currentQty;
  }
  // Update and notify
  row.quantity = newQty.toString();
  inventoryChanged(product, index, newQty);
};

const updateCartProductQuantity = async () => {
  quantityBtnDisable.value = true;
  try {
    const response = await CustomerAPIService.updateCartProductQuantity(
      { products: products.value });
    if (response.data?.success) {
      toast.success(response.data.success);
      getCartProducts();
      quantityBtnDisable.value = false;
    } else if (response.data?.error) {
        quantityBtnDisable.value = false;
      toast.error(response.data.error);
    }
  } catch (error) {
    getCartProducts();
    toast.error("Error Exception!");
  } finally {
    quantityBtnDisable.value = false;
  }
};

const decrementCartProductUI = (product, index) => {
    let quantity = 0;
    const row = products.value.find(row => row.cartProduct_id == product.cartProduct_id);
    if (!row) return;
    const allowMultiple = store.getters.brand['allow_multiple_of_minimum_purchase_quantity'] == "1";
    if (product.min_purchase_quantity) {
        quantity = parseFloat(row.quantity) - (allowMultiple ? parseFloat(product.min_purchase_quantity) : 1);
        if (quantity >= product.min_purchase_quantity) {
            row.quantity = quantity.toString();
        } else if (quantity < product.min_purchase_quantity) {
            toast.warning(`Minimum purchase quantity is ${product.min_purchase_quantity}.`);
        }
        if (row.quantity == 0) {
            products.value.splice(index, 1);
        }
    } else {
        quantity = parseFloat(row.quantity) - (allowMultiple ? parseFloat(product.min_purchase_quantity) : 1);
        if (quantity >= 1) {
            row.quantity = quantity.toString();
            // to remove product from list
            if (row.quantity == 0) {
                products.value.splice(index, 1);
            }
        }
    }
    inventoryChanged(product, index, quantity);
};

const recalculateTotal = () => {
  let new_total = 0;
  products.value.forEach(product => {
  if (product.hasOwnProperty('quantity')) {
        new_total = new_total + product.quantity * product.dp;
      } else {
        new_total = new_total + 1 * product.dp;
      }
  })
  subtotal.value = new_total;
};

const inventoryChanged = (product, productIndex, qty_ordered) => {
  if (product.uses_volume_price_tiers) {
    const wholesale_price = document.getElementById(`wholesaleValue-${product.sku}`);
    // Find the first matching volume price tier based on the ordered quantity
    const matchingTier = product.volume_price_tiers.find((row, index) => {
      return (qty_ordered >= row.min && qty_ordered <= row.max) || qty_ordered > row.max;
    });
    if (matchingTier) {
      product.dp = matchingTier.price;
      products.value.splice(productIndex, 1, { ...product });
    } else {
      // Handle the case where no matching tier is found (for qty_ordered < min)
      const firstTier = product.volume_price_tiers[0];
      if (qty_ordered < firstTier.min) {
        product.dp = product.volume_dp;
        products.value.splice(productIndex, 1, { ...product });
      }
    }
    recalculateTotal();
  } else {
    recalculateTotal();
  }
};

</script>
<style scoped>
@media(max-width: 430px){
    .cart-dropdown{
        width: 400% !important;
        overflow-x:auto !important;
    }
}
    .cartheaderBorder{
     border-bottom: 1px solid #cdc5c5 !important;
   }
  .btn.btn-light-primary{
    background-color: #5caae2;
    border-color:transparent;
    }

  .btn.btn-light-primary i {
    color: #ffffff; }
.btn.btn-light-primary:hover:not(.btn-text):not(:disabled):not(.disabled), .btn.btn-light-primary:focus:not(.btn-text), .btn.btn-light-primary.focus:not(.btn-text) {
    color: #FFFFFF;
    background-color: #007bff;
    border-color: transparent;
 }
.btn.btn-icon.btn-circle {
    border-radius: 50% !important;
}
.scroll {
    position: relative;
    overflow: hidden;
}
.ps {
    overflow: hidden!important;
    overflow-anchor: none;
    -ms-overflow-style: none;
    touch-action: auto;
    -ms-touch-action: auto;
}
.cart-scrollable{
    overflow-y: auto;
    max-height: 232px;
    min-height: 232px;
    }
</style>
